import { render, staticRenderFns } from "./PensionCapitalGrowthTable.vue?vue&type=template&id=c03eea08"
import script from "./PensionCapitalGrowthTable.vue?vue&type=script&lang=js"
export * from "./PensionCapitalGrowthTable.vue?vue&type=script&lang=js"
import style0 from "./PensionCapitalGrowthTable.vue?vue&type=style&index=0&id=c03eea08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PensionCapitalGrowthTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports